import { render } from "./ShippingCodes.vue?vue&type=template&id=35015029&scoped=true"
import script from "./ShippingCodes.vue?vue&type=script&lang=js"
export * from "./ShippingCodes.vue?vue&type=script&lang=js"

import "./ShippingCodes.vue?vue&type=style&index=0&id=35015029&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35015029"]])

export default __exports__